import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Text, Button, Box } from '@chakra-ui/react';
import { Colors } from '../../../../static/static';

function Details({homepage=true}) {
  const navigate = useNavigate();

  const info = homepage
    ? [
        { title: "תלמידים ממליצים", path: "/recommendations" },
        { title: "שיטה יחודית", path: "/syllabus" },
        { title: "צוות המורים", path: "/teachers" },
        { title: "קורס דיגיטלי", path: "/syllabus" },
      ]
    : [
        { title: "תלמידים ממליצים", path: "/recommendationsLanding" },
        { title: "צוות המורים", path: "/teachersLanding" },
      ];


  const handleNavigate = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <Flex
      height={{ base: "100%", md: homepage ? '35vh': '32vh', lg: homepage ? '30vh' : '20vh' }}
      direction="row"
      justify="space-around"
      align="center"
      wrap="wrap"
      p={4}
      bg={Colors.bgBlue}
    >
      {info.map((item, index) => (
        <Button
          key={index}
          onClick={() => handleNavigate(item.path)} 
          as="div"
          h={{ base: "8dvh", md: "15dvh" }}
          w={{ base: "35dvh",  md: "31dvh", xl: homepage ? "31dvh" : "45dvh" }}
          padding="0.5%"
          borderWidth={1}
          borderRadius="lg"
          borderColor="gray.200"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          bg={Colors.bgText}
          boxShadow="md"
          mb={4}
          mt={3}
          mx={2}
          _hover={{ bg: "gray.200", cursor: "pointer" }}
        >
          <Text fontSize={{ base: "4dvh", md: "3.5dvh" }} dir="rtl">
            <b>{item.title}</b>
          </Text>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Text fontSize={{ base: "2dvh" }}>(לחצו עלי)</Text>
          </Box>
        </Button>
      ))}
    </Flex>
  );
}

export default Details;
